import { Flashbar } from "@amzn/awsui-components-react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";

import ExportsTable from "components/ExportsTable/ExportsTable";
import { useState } from "react";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import Paths from "../../common/paths/paths";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.Admin.url },
        { text: Paths.exports.name, href: Paths.exports.url },
    ],
};

const ExportsPage = () => {
    const flashBarItemsHook = useFlashBarItems();
    const [navigationOpen, setNavigationOpen] = useState(false);

    return (
        <AppLayout
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
            toolsHide={true}
            content={
                <ExportsTable useFlashBarItemsActions={flashBarItemsHook.actions}></ExportsTable>
            }
        />
    );
};

export default ExportsPage;
